const hasApprovalValue = (value) => {
  if (value === null || value === undefined || value === false) return false;
  if (value === 0 || value === '0') return false;
  return String(value).trim() !== '';
};

// Approval Kacab/HC adalah tahap terakhir pada seluruh alur pengajuan izin.
export const isIzinFullyApproved = (item = {}) =>
  hasApprovalValue(item.ttd_kacab);

export const isPendingIzin = (item = {}) =>
  !isIzinFullyApproved(item);
